import React from "react"

class FileUploadsDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.length) {
      return (
        <ul style={{ margin: 0, padding: 0 }}>
          {
            this.props.data.map((file) => {
              return (
                <li key={file.name}>{file.name}</li>
              )
            })
          }
        </ul>
      )
    } else {
      return null;
    }
  }
};

export default FileUploadsDataType